let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("8bkDf"), load("iZHNx")]).then(() => parcelRequire('4dgmL'));